import UserManagementModule from './user-management-module';
export default UserManagementModule;
